<template>
<div class="chapter">
<div class="inner_page">
<div id="AQy">
<h1 class="h1" id="pz9-1"><a href="#/contenttoc#x1">ACKNOWLEDGMENTS</a></h1>
<p class="noindent2" id="pAhs-"><span class="dropcap">T</span>his book seeks both to describe who Churches of Christ have been and to propose a constructive vision for the future. Given the difficulty of the task, it was clear from the beginning that this should be a multiauthor work. Each author wrote two main chapters (<span href="#/chapter02" title="Link target outside of Sample">Chapters Two</span> to <span href="#/chapter07" title="Link target outside of Sample">Seven</span>), and each chapter was revised based on the input of the other two authors. In addition, Mark Powell wrote <a href="#/chapter01">Chapters One</a> and <span href="#/chapter08" title="Link target outside of Sample">Eight</span> and served as the general editor of the work. As is evident from the chapters, the authors have different approaches, styles, and temperaments, and yet the goal was to provide a coherent vision on which we all could agree. We believe that the result of this process has been a better and more comprehensive proposal. As an editorial decision, the authors used gender-neutral language, but we did not alter historical quotations.</p>
<p class="indent" id="pz9-3">The authors sincerely thank the three respondents, who engaged this book in a thoughtful and timely fashion. The responses offer important additional perspectives and, we believe, show the fruitfulness of the primary proposal. We also thank two graduate assistants, Robert Ogden and Eli Randolph, who provided valuable support in the research and production of this <span id="z10-1">book. Of course, we are grateful to Jason Fikes and everyone at ACU Press for their quality work and for agreeing to make this proposal available to a larger audience.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?093092ba